/**
 * JWT 토큰 디코딩 유틸리티 함수
 */
export const decodeJWT = (token: string) => {
  try {
    // JWT는 3부분으로 구성: header.payload.signature
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("JWT 디코딩 오류:", error);
    return null;
  }
};

/**
 * JWT 토큰에서 사용자 정보 추출
 */
export const extractUserInfoFromToken = (token: string) => {
  const payload = decodeJWT(token);
  if (!payload) return null;

  return {
    userId: payload.userId || payload.sub || payload.id,
    userName: payload.userName || payload.name || payload.username,
    email: payload.email || "",
  };
};

/**
 * 로그아웃 처리 유틸리티 함수
 */
export const handleLogout = () => {
  // 로컬 스토리지에서 인증 관련 데이터 제거
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("userInfo");

  // 로그인 페이지로 리다이렉트
  window.location.href = "/auth";
};
